$(document).ready(function(){
    $('.product-slider').slick({
      slidesToShow: 1.5, // Exibe 1 imagem inteira e metade da próxima no desktop
      slidesToScroll: 1,
      arrows: true, // Ativa as setas de navegação
      dots: true, // Ativa os dots
      infinite: false, // Desativa o comportamento infinito
      customPaging: function(slider, i) {
        var thumb = $(slider.$slides[i]).find('.slider-item').data('thumb');
        var poster = thumb ?? "https://cdn.shopify.com/s/files/1/0865/9134/0841/files/video.png?v=1726088859";
        
        return '<button style="background-image:url(' + poster +');"></button>';
      },
      responsive: [
        {
          breakpoint: 768, // Mobile breakpoint
          settings: {
            slidesToShow: 1, // Exibe uma imagem por vez no mobile
            slidesToScroll: 1
          }
        }
      ]
    });
  });
  